<template>
	<div class="login" :style="{ height: $pageHeight() + 'px' }">
		<div class="login-img">
			<img src="../../assets/common/loginBanner.png" />
		</div>
		<div class="login-area">
			<div class="login-area-title">
				<span>日程安排管理系统</span>
			</div>
			<div class="login-area-input">
				<img class="login-input-icon" src="../../assets/common/icons/loginUser.png" />
				<el-input placeholder="工号" v-model="userNumber"></el-input>
			</div>
			<div class="login-btn" @click="login">
				<span>登录</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {

		},
		data() {
			return {
				userNumber: '', //工号
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {

			})
		},
		methods: {
			//登录
			login() {
				let that = this;
				let params = {
					number: that.userNumber
				};
				that.$api.login(params).then(res => {
					console.log(res)
					if (res.code == 1) {
						localStorage.setItem('userInfo', JSON.stringify(res.data));
						that.$router.replace("/home");
					}
				}).catch(err => {
					console.log(err)
				})
			}
		},
	}
</script>

<style lang="scss">
	.login {
		background-color: #F4FAFE;

		.el-input__inner {
			border: 0;
			font-weight: 400;
			color: #999999;
		}

		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;

		.login-img {
			img {}
		}

		.login-area {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background-color: #E4EFFE;
			border: 1px solid #D0E2FA;

			.login-area-title {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				opacity: 0.85;

				span {
					font-weight: 400;
					color: #2E6BCF;
				}
			}

			.login-area-input {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;
				background-color: #fff;
				width: 100%;

				.login-input-icon {
					border-right: 1px solid #999999;
				}
			}

			.login-btn {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				background: #1A66FE;
				width: 100%;
				cursor: pointer;

				span {
					font-weight: 400;
					color: #FFFFFF;
				}
			}
		}
	}

	@media screen and (min-width: 1024px) {
		.login {
			.el-input__inner {
				font-size: 21px;
			}
		
			.login-img {
				margin: 0 48px 0 0;
		
				img {
					width: 420px;
					height: 351px;
				}
			}
		
			.login-area {
				padding: 78px 40px 88px;
				border-radius: 14px;
		
				.login-area-title {
					span {
						font-size: 26px;
					}
				}
		
				.login-area-input {
					margin: 71px 0 93px;
					padding: 8px 10px 8px 27px;
					border-radius: 4px;
		
					.login-input-icon {
						width: 29px;
						height: 29px;
						padding: 0 12px 0 0;
					}
				}
		
				.login-btn {
					border-radius: 24px;
					padding: 12px 0;
					margin: 0 2px;
		
					span {
						font-size: 21px;
					}
				}
			}
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.login {
			.el-input__inner {
				font-size: 35px;
			}

			.login-img {
				margin: 0 80px 0 0;

				img {
					width: 690px;
					height: 576px;
				}
			}

			.login-area {
				padding: 78px 40px 88px;
				border-radius: 23px;

				.login-area-title {
					span {
						font-size: 42px;
					}
				}

				.login-area-input {
					margin: 71px 0 93px;
					padding: 18px 10px 18px 27px;
					border-radius: 7px;

					.login-input-icon {
						width: 47px;
						height: 47px;
						padding: 0 20px 0 0;
					}
				}

				.login-btn {
					border-radius: 40px;
					padding: 20px 0;
					margin: 0 5px;

					span {
						font-size: 35px;
					}
				}
			}
		}
	}

	@media screen and (min-width: 1920px) {}
</style>